export default __webpack_public_path__ + "static/media/Image5.989b9d78.png";